import { Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { Translate, I18n } from 'react-redux-i18n';

import { SUPPORT, ADMIN, SUPPORT_ADMIN, MANAGER } from 'app/constants';

export default class extends React.Component {
  constructor() {
    super();
    this.logout = this.logout.bind(this);
  }

  logout(e) {
    e.preventDefault();
    this.props.logout();
  }

  renderMainNavigation = () => {
    const {
      user: { role },
    } = this.props;

    switch (role) {
      case ADMIN:
        return (
          <Fragment>
            <NavLink to="/" exact className="nav-link" activeClassName="active">
              <Translate value="layout.navs.dashboard" />
            </NavLink>
            <span className="nav-devider mx-2">|</span>
            <NavLink
              to="/releases"
              className="nav-link"
              activeClassName="active"
            >
              <Translate value="layout.navs.releases" />
            </NavLink>
            <span className="nav-devider mx-2">|</span>
            <NavLink to="/users" className="nav-link" activeClassName="active">
              <Translate value="layout.navs.users" />
            </NavLink>
            <span className="nav-devider mx-2">|</span>
            <NavLink
              to="/qr-diagnostics"
              className="nav-link"
              activeClassName="active"
            >
              <Translate value="layout.navs.qr_diagnostics" />
            </NavLink>
          </Fragment>
        );
      case SUPPORT_ADMIN:
        return (
          <Fragment>
            <NavLink
              to="/qr-diagnostics"
              className="nav-link"
              activeClassName="active"
            >
              <Translate value="layout.navs.qr_diagnostics" />
            </NavLink>
            <span className="nav-devider mx-2">|</span>
            <NavLink to="/users" className="nav-link" activeClassName="active">
              <Translate value="layout.navs.users" />
            </NavLink>
          </Fragment>
        );
      case MANAGER:
        return (
          <Fragment>
            <NavLink to="/" exact className="nav-link" activeClassName="active">
              <Translate value="layout.navs.dashboard" />
            </NavLink>
            <span className="nav-devider mx-2">|</span>
            <NavLink
              to="/releases"
              className="nav-link"
              activeClassName="active"
            >
              <Translate value="layout.navs.releases" />
            </NavLink>
            <span className="nav-devider mx-2">|</span>
            <NavLink
              to="/qr-diagnostics"
              className="nav-link"
              activeClassName="active"
            >
              <Translate value="layout.navs.qr_diagnostics" />
            </NavLink>
          </Fragment>
        );
      case SUPPORT:
        return (
          <Fragment>
            <NavLink
              to="/qr-diagnostics"
              className="nav-link"
              activeClassName="active"
            >
              <Translate value="layout.navs.qr_diagnostics" />
            </NavLink>
          </Fragment>
        );
      default:
        return null;
    }
  };

  render() {
    const {
      user: { name },
    } = this.props;

    return (
      <header className="header">
        <div className="header_brand">
          <div className="header_logo">
            <img src="/brand.png" alt={I18n.t('layout.brand')} />
          </div>
          <h3 className="header_title">
            <Translate value="layout.brand" />
            {process.env.APP_ENV == 'staging' && (
              <div className="small">STAGING</div>
            )}
          </h3>
        </div>

        <div className="header_nav">
          <nav className="nav nav--layout">{this.renderMainNavigation()}</nav>
          <div className="header_profile">
            <div className="header_profile_name">
              <label>
                <Translate value="layout.profile" />
              </label>
              {name}
            </div>
            <div className="header_profile_avatar">
              <span className="fa fa-user fa-2x" />
            </div>
            <div className="dropdown-menu header_profile_menu">
              <a href="#" className="dropdown-item" onClick={this.logout}>
                <Translate value="layout.logout" />
              </a>
            </div>
          </div>
        </div>
      </header>
    );
  }
}
